var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUjinWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 68,
  height: 39,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M41.524 5.028H36.5V0a5.027 5.027 0 0 1 5.025 5.028Z",
  fill: "#28F8FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.358 8.028h-5.056V28.9h-4.846a5.901 5.901 0 0 1-5.9-5.902V12.245a4.215 4.215 0 0 0-4.213-4.217H.5v14.547c0 6.054 4.905 10.962 10.956 10.962h9.902V8.028ZM26.415 8.028h5.057v25.51a5.058 5.058 0 0 1-5.057 5.059V8.028ZM36.528 8.028h5.057v25.51h-5.057V8.027ZM46.642 8.028v25.51h5.056V12.665h4.846c3.258 0 5.9 2.643 5.9 5.903v10.752a4.215 4.215 0 0 0 4.213 4.216h.843V18.991c0-6.055-4.905-10.963-10.956-10.963h-9.902Z",
  fill: "#fff"
})));
export default SvgUjinWhite;